<template>
  <div>
    <div class="canvas-box" id="myBeRadarChart"></div>
  </div>
</template>

<script>
export default {
  props: ["model", "behaviorResult", "beScore"],
  data() {
    return {
      colors: [],
      color: [
        "#6AC4EE",
        "#EB766E",
        "#F6B250",
        "#A3D36C",
        "#8882E8",
        "#8599A3",

        "#95582A",
        "#7C8577",
        "#028792",
        "#80752C",
      ],
    };
  },
  mounted() {
    this.loadData();
    this.renderMap();
  },
  watch: {
    behaviorResult(val) {
      if (val.length > 0) {
        this.loadData();
        this.renderMap();
      }
    },
  },
  methods: {
    renderMap() {
      if (this.behaviorResult != null) {
        let myRadarChart = this.$echarts.init(
          document.getElementById("myBeRadarChart"),
          null,
          { renderer: "svg" }
        );
        // let indicators = new Array(5).fill({ max: 10 });
        let indicators = [];

        for (let i = 0; i < this.behaviorResult.level2.length; i++) {
          indicators.push({ max: 10 });
        }

        let seriesData = [];
        this.behaviorResult.level2.map((item, index) => {
          let c = Object.assign({}, this.colors[index]);
          c = Object.assign(c, { name: item.name });
          seriesData.push(c);
        });
        let startAngle = 30;
        let intv = 360 / this.beScore.length;
        startAngle = 90 - intv / 2;
        let option = {
          color: ["#69C5EF"],
          radar: {
            shape: "circle",
            indicator: indicators,
          },
          animation: false,
          series: [
            {
              type: "pie",
              startAngle: startAngle,
              radius: ["75%", "99.1%"],
              labelLine: {
                show: false,
              },
              label: {
                position: "inner",
                fontWeight: "bolder",
                color: "#fff",
                fontSize: 12,
              },
              data: seriesData,
            },
            {
              type: "radar",
              data: [
                {
                  value: this.beScore.reverse(),
                  name: "测试者标准分",
                  lineStyle: {
                    color: "#69C5EF",
                    type: "dashed",
                  },
                  label: {
                    show: true,
                    color: "#ff0000",
                  },
                  areaStyle: {
                    color: "#69C5EF",
                    opacity: 0.4, // 图形透明度
                  },
                },
                // {
                //   value: [9, 9, 9, 9, 9, 9],
                //   name: "群体平均分",
                //   lineStyle: {
                //     type: "dashed",
                //   },
                //   areaStyle: {
                //     color: "#FF917C",
                //     opacity: 0.2, // 图形透明度
                //   },
                // },
              ],
            },
          ],
        };
        myRadarChart.setOption(option);
      }
    },
    loadData() {
      this.behaviorResult.level2.map((item, index) => {
        this.colors.push({
          name: item.name,
          value: 1000,
          itemStyle: {
            color: this.color[index],
            borderWidth: 3,
            borderColor: "#fff",
          },
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.canvas-box {
  width: 460px;
  height: 480px;
  margin: 1px auto 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/echarts/behavior/beLatitudeRadar.vue